import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { getAxios } from "src/helpers/index";
import { notificationObject } from "src/constant";


export const setAllFilterDataToRedux = createAction(
  "goodsin/setAllFilterDataToRedux",
  (model) => {
    return { payload: model };
  }
);


export const setRightSideBarOpenCloseValue = createAction(
  "goodsin/setRightSideBarOpenCloseValue",
  (model) => {
    return { payload: model };
  }
);



export const setSelectedProjectDropdownValue = createAction(
  "goodsin/setSelectedProjectDropdownValue",
  (model) => {
    return { payload: model };
  }
);

//get All GoodsIN section
export const getAllGoodsInData1 = createAsyncThunk(
  "goodsin/getAllGoodsInData1",
  async (model, thunkAPi) => {
    try {
      let url = "/Shipment/GetAllShipments";
      if (model?.from) {
        url = `${url}?from=${model?.from}`;
      }
      if (model?.to) {
        url = `${url}&to=${model?.to}`;
      }
      if (model?.DepotIds) {
        url = `${url}&depotIds=${model?.DepotIds}`;
      }
      if (model?.ClientIds) {
        url = `${url}&clientIds=${model?.ClientIds}`;
      }
       
      if (model?.ProjectIds) {
        url = `${url}&projectIds=${model?.ProjectIds}`;
      }
      {
        url = `${url}&isDateRange=${model?.isDateRange}&currentPage=${model?.currentPage || 1}&pageSize=${model?.pageSize || 1000}&status=${model?.status || ""}&referenceNumber=${model?.referenceNumber || ""}`;
      }

      let res = await getAxios().get(`${url}`);
      return res?.data || [];
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

//get All GoodsIN section
export const getAllGoodsInData = createAsyncThunk(
  "goodsin/getAllGoodsInData",
  async (model, thunkAPi) => {
    try {
      let url = "/shipment";
      if (model?.from) {
        url = `${url}?from=${model?.from}`;
      }
      if (model?.to) {
        url = `${url}&to=${model?.to}`;
      }
      if (model?.DepotIds) {
        url = `${url}&depotIds=${model?.DepotIds}`;
      }
      if (model?.ClientIds) {
        url = `${url}&clientIds=${model?.ClientIds}`;
      }
      if (model?.ProjectIds) {
        url = `${url}&projectIds=${model?.ProjectIds}`;
      }
      {
        url = `${url}&isDateRange=${model?.isDateRange}&currentPage=${model?.currentPage || 1}&pageSize=${model?.pageSize || 1000}&status=${model?.status || ""}&referenceNumber=${model?.referenceNumber || ""}`;
      }

      let res = await getAxios().get(`${url}`);
      return res?.data || [];
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const getAllGoodsInDataLoading = createAsyncThunk(
  "goodsin/getAllGoodsInDataLoading",
  async (model, thunkAPi) => {
    try {
      let url = "/Shipment/GetAllShipments";
      if (model?.from) {
        url = `${url}?from=${model?.from}`;
      }
      if (model?.to) {
        url = `${url}&to=${model?.to}`;
      }
      if (model?.DepotIds) {
        url = `${url}&depotIds=${model?.DepotIds}`;
      }
      if (model?.ClientIds) {
        url = `${url}&clientIds=${model?.ClientIds}`;
      }
      if (model?.ProjectIds) {
        url = `${url}&projectIds=${model?.ProjectIds}`;
      }
      {
        url = `${url}&isDateRange=${model?.isDateRange}&currentPage=${model?.currentPage || 1}&pageSize=${model?.pageSize || 1000}&status=${model?.status || ""}&referenceNumber=${model?.referenceNumber || ""}`;
      }
      let res = await getAxios().get(`${url}`);
      return res?.data || [];
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const addNewGoodsInData = createAsyncThunk(
  "goodsin/addNewGoodsInData",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().post("/shipment", model);
      let notficationObj = {
        ResourceId: res?.data,
        ReferenceNumber: model?.referenceNumber,
        TimeStamp: new Date().toISOString(),
        DepotId: model?.depotId,
        Location: model?.depotCode,
        ClientName: model?.ClientName,
        ProjectId: model?.projectId,
        ...notificationObject("Shipment", "Create")
      }
      let notficationObj1 = {
        ResourceId: res?.data,
        ReferenceNumber: model?.referenceNumber,
        TimeStamp: new Date().toISOString(),
        DepotId: model?.depotId,
        Location: model?.depotCode,
        ClientName: model?.ClientName,
        ...notificationObject("Shipment", "Create")
      }
      if (model.role == "SuperAdmin" || model?.role == "Admin") {
        await thunkAPi.dispatch(approveGoodsinAction({
          id: res.data,
          approveAction: 0,
          isAdmin: true
        }))
      }
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(model?.role == "DepotManager" ? notficationObj1 : notficationObj)] });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const editGoodsInRecord = createAsyncThunk(
  "goodsin/editGoodsInRecord",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().put(`/shipment/${model?.id}`, model);
      let notficationObj = {
        ResourceId: model?.id,
        ReferenceNumber: model?.referenceNumber,
        TimeStamp: new Date().toISOString(),
        DepotId: model?.depotId,
        Location: model?.depotCode,
        ClientName: model?.ClientName,
        ProjectId: model?.projectId,
        ...notificationObject("Shipment", "Update")
      }
      let notficationObj1 = {
        ResourceId: model?.id,
        ReferenceNumber: model?.referenceNumber,
        TimeStamp: new Date().toISOString(),
        DepotId: model?.depotId,
        Location: model?.depotCode,
        ClientName: model?.ClientName,
        ...notificationObject("Shipment", "Update")
      }
      if (model.role == "SuperAdmin" || model?.role == "Admin") {
        await thunkAPi.dispatch(approveGoodsinAction({ id: model?.id, approveAction: 0, isAdmin: true }))
      }
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(model?.role == "DepotManager" ? notficationObj1 : notficationObj)] });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const approveGoodsinAction = createAsyncThunk(
  "goodsin/approveGoodsinAction",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().put("/shipment/Approve", model);
      if (!model?.isAdmin) {
        let notficationObj = {
          ResourceId: parseInt(model?.id),
          ReferenceNumber: model?.referenceNumber,
          TimeStamp: new Date().toISOString(),
          DepotId: model?.depotId,
          Location: model?.depotCode,
          ClientName: model?.ClientName,
          ProjectId: model?.projectId,
          ...notificationObject("Shipment", model?.approveAction == 1 ? "Revoke" : "Approve")
        }
        let notficationObj1 = {
          ResourceId: parseInt(model?.id),
          ReferenceNumber: model?.referenceNumber,
          TimeStamp: new Date().toISOString(),
          DepotId: model?.depotId,
          Location: model?.depotCode,
          ClientName: model?.ClientName,
          ...notificationObject("Shipment", model?.approveAction == 1 ? "Revoke" : "Approve")
        }

        await getAxios().post("/ActivityLog", { activityLogs: [model?.approveAction == 1 ? JSON.stringify(notficationObj1) : JSON.stringify(notficationObj)] });
      }
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);


export const getGoodsInSingleData = createAsyncThunk(
  "goodsin/getGoodsInSingleData",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`/shipment/${model.id}`);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const deleteGoodsinRecord = createAsyncThunk(
  "goodsin/deleteGoodsinRecord",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().delete(`/shipment/${model.id}`);
      let notficationObj = {
        ResourceId: parseInt(model?.id),
        ReferenceNumber: model?.referenceNumber,
        TimeStamp: new Date().toISOString(),
        DepotId: model?.depotId,
        Location: model?.depotCode,
        ClientName: model?.ClientName,
        ProjectId: model?.projectId,
        ...notificationObject("Shipment", "Remove")
      }
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);



export const Addremarks = createAsyncThunk(
  "goodsin/Addremarks",
  async (model, thunkAPi) => {
    try {
      let module = model?.apiModule || ''
      delete model?.apiModule
      let res = await getAxios().post(`/${module}/${model?.id}/Remarks`, model);
      let notficationObj = {
        ResourceId: parseInt(model?.id),
        ReferenceNumber: model?.referenceNumber,
        TimeStamp: new Date().toISOString(),
        userDetails: model?.userDetails,
        DeliveryOrderType: model?.DeliveryOrderType,
        DeliveryOrderNo: model?.DeliveryOrderNo,
        projectId: model?.projectId,
        ...notificationObject(module == "Shipment" ? "Shipment" : "Delivery Order", module == "Shipment" ? "Shipment Remarks" : "Delivery Order Remarks")
      }
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);
